module.exports = __webpack_public_path__ + "static/media/mail.bc216e67.svg";